module.exports = __webpack_public_path__ + "static/media/arrow-conference.55f2a21c.svg";